"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPrevMinute;

function getPrevMinute(value) {
  var number = Number(value);

  if (!value || number === 0) {
    return '59';
  }

  return String(number - 1);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/TimePicker/helpers/getPrevMinute.js
// module id = rVi0
// module chunks = 0